import { Component, OnInit, Input, inject } from '@angular/core';
import { ClientProgramMetrics } from 'app/core/models/client-program-metrics.model';
import { Client } from 'app/core/models/client.model';
import { ClientsService } from 'app/core/services/clients.service';
import { DecimalPipe, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { ClientNetSavingsTrendBySourceComponent } from '../client-net-savings-trend-by-source/client-net-savings-trend-by-source.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';

@Component({
    selector: 'app-client-program-metrics',
    templateUrl: './client-program-metrics.component.html',
    styleUrls: ['./client-program-metrics.component.scss'],
    imports: [MatIcon,
              ClientNetSavingsTrendBySourceComponent,
              MatProgressSpinner,
              DecimalPipe,
              DatePipe,
              BlankValueDashPipe]
})
export class ClientProgramMetricsComponent implements OnInit {
  private clientService = inject(ClientsService);

  @Input() client: Client;
  clientProgramMetrics: ClientProgramMetrics;
  loadingProgramMetrics: boolean = true;

  ngOnInit() {
    this.init();
  }

  private init() {
    this.clientService.getProgramMetrics(this.client.id).subscribe(clientProgramMetrics => {
      this.clientProgramMetrics = clientProgramMetrics;
      this.loadingProgramMetrics = false;
    });
  }
}
